import { useQuery } from "@tanstack/react-query";
import OrgService from "../services/Org/OrgService";

export const useSupplierOrgs = () => {
    return useQuery({
        queryKey: ["supplierOrgs"],
        queryFn: () => OrgService.getAllSupplierOrgsDropDown().then(res => res.data),
        staleTime: Infinity,
        cacheTime: Infinity,
        placeholderData: (prevData) => prevData
    });
};